module.exports = __webpack_public_path__ + "static/media/1.83392801.png";